import React, { useState } from "react";
import { toast } from "sonner";
import { errMsg, FIELD_LABELS, useApi } from "../../lib/api";
import { ProtectedTag } from "../../components/kit";

export function ConsentPanel({ requestId, candidate, onDone, onCancel }: { requestId: string; candidate: any; onDone: () => void; onCancel: () => void }) {
  const api = useApi();
  const [fields, setFields] = useState<string[]>(["full_name", "phone"]);
  const [purpose, setPurpose] = useState(`Contact me to quote and schedule this job.`);
  const [busy, setBusy] = useState(false);
  const toggle = (f: string) => setFields((s) => (s.includes(f) ? s.filter((x) => x !== f) : [...s, f]));
  const submit = async () => {
    setBusy(true);
    try {
      const r = await api("post", `/customer/requests/${requestId}/consents`, { candidate_id: candidate.candidate_id, fields, purpose });
      toast.success(r.consent_created ? `Details shared with ${candidate.vendor_name}` : "Consent already active — no duplicate introduction created");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="protected-zone mt-3 space-y-3" data-testid="consent-panel">
      <ProtectedTag text="Separate step: share your details" />
      <p className="text-sm">Share with <strong>{candidate.vendor_name}</strong> only. Valid 7 days. Any change to protected fields, trade or area voids it.</p>
      <fieldset>
        <legend className="label">Exact fields to share</legend>
        <div className="flex flex-wrap gap-3">
          {Object.keys(FIELD_LABELS).map((f) => (
            <label key={f} className="flex items-center gap-2 rounded border border-[var(--steel)] bg-white px-2 py-1 text-sm">
              <input type="checkbox" checked={fields.includes(f)} onChange={() => toggle(f)} data-testid={`consent-field-${f}-checkbox`} />
              {FIELD_LABELS[f]}
            </label>
          ))}
        </div>
      </fieldset>
      <div>
        <label className="label" htmlFor="consent-purpose">Purpose</label>
        <textarea id="consent-purpose" rows={2} className="input" value={purpose} onChange={(e) => setPurpose(e.target.value)} data-testid="consent-purpose-input" />
      </div>
      <div className="flex flex-wrap gap-2">
        <button className="btn btn-primary" disabled={busy || fields.length === 0 || purpose.trim().length < 5} onClick={submit} data-testid="consent-confirm-button">
          {busy ? "Sharing…" : `Approve & share ${fields.length} field${fields.length === 1 ? "" : "s"}`}
        </button>
        <button className="btn btn-ghost" onClick={onCancel} data-testid="consent-cancel-button">Cancel</button>
      </div>
    </div>
  );
}
